/*
  import { lotFileDocumentStore } from '@/services/LotFileDocument/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem, notifyError, notifyMessage } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await lotFileDocumentStore.dispatch ('getLotFileDocumentList', {
      hoaId
    });
  */

  async getLotFileDocumentList({}, { unitID, ownerID, includeSignedUrls }) {
    console.log('in getLotFileDocumentList...' + unitID + ', ' + ownerID + ', ' + includeSignedUrls)
    try {
      const params = {
        unitID,
        ownerID,
        includeSignedUrls
      }

      const results = await kms.get(`/LotFiles/LotFileDocument/List`, {
        params
      })

      if (isDebug == true) console.debug('getLotFileDocumentList log=' + JSON.stringify(results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The Lot File Document list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async getLotFileCategoryList({}, { hoaID }) {
    console.log('in getLotFileCategoryList...' + hoaID)
    try {
      const params = {
        hoaID
      }

      const results = await kms.get(`/LotFiles/LotFileCategory/List`, {
        params
      })

      if (isDebug == true) console.debug('getLotFileCategoryList log=' + JSON.stringify(results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The Lot File Category list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async updateLotFileDocument({ dispatch }, { payload = {}, done }) {
    try {
      if (isDebug === true)
        console.debug('updateLotFileDocument payload=' + JSON.stringify(payload))

      const results = await kms.put(`/LotFiles/LotFileDocument`, payload)

      console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results.lotFileDocumentID > 0) {
        notifyMessage(`Successfully updated the lot file document.`)
        done()
      } else {
        notifyError('There was a problem updating this lot file document.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem processing the update for this lot file document.`)
      console.error(exception)
    }
  },

  async getUniqueCategories({}, { rows }) {
    try {
      console.debug('getUniqueCategories...' + JSON.stringify(rows))
      let resultList = []
      let myList = []
      rows.forEach(f => {
        if (f && f.lotFileCategory !== undefined && f.lotFileCategory.name !== undefined) {
          const filterCategory = {
            label: f.lotFileCategory.name || '',
            value: f.lotFileCategoryID,
            filter: ''
          }

          if (f.lotFileCategory.name !== '') {
            myList.push(filterCategory)
          }
        }
      })

      if (!myList) {
        myList = [
          {
            label: 'All',
            value: 0,
            filter: ''
          }
        ]
      }

      resultList = [...new Set(myList)]

      return {
        list: resultList
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving unique filter categories`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async getFile({}, { params = {} }) {
    try {
      const result = await kms.get(`/LotFiles/LotFileDocument/GetFile`, {
        params
      })

      if (isDebug == true) console.debug('getFile=' + result)

      return {
        returned: result
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving the lot file document file.`)
      console.error(exception)
    }

    return {
      returned: null
    }
  },

  async getDocumentFromPath({}, { path }) {
    try {
      const result = await kms.getfrompath(path)

      if (isDebug == true) console.debug('getDocumentFromPath=' + result)

      return {
        returned: result
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving signed document.`)
      console.error(exception)
    }

    return {
      returned: null
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const lotFileDocumentStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
